import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    input: {
        // marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
}));

export default ({handleChange}) => {
    const classes = useStyles();

    return (
        <Paper component="form" className={classes.root} style={{backgroundColor: 'none', padding: '10px 10px'}}>
            <InputBase
                className={classes.input}
                placeholder="Search Country"
                onChange={handleChange}
                inputProps={{'aria-label': 'search google maps'}}
            />
            <IconButton type="submit" className={classes.iconButton} aria-label="search" style={{padding: 0}}>
                <SearchIcon style={{padding: 0}}/>
            </IconButton>
        </Paper>
    );
}